module.exports = __webpack_public_path__ + "img/grid.5941e268.svg";